import { render, staticRenderFns } from "./Profitbill.vue?vue&type=template&id=2417d2d2&scoped=true"
import script from "./Profitbill.vue?vue&type=script&lang=js"
export * from "./Profitbill.vue?vue&type=script&lang=js"
import style0 from "./Profitbill.vue?vue&type=style&index=0&id=2417d2d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2417d2d2",
  null
  
)

export default component.exports